import {
  IFeatureModalData,
  IControlButtonTexts
} from 'module/productfeaturemodal/productfeaturemodal.types'

export const bloctoFeatureModalData: IFeatureModalData[] = [
  {
    image: '/assets/Image/blocto-popup.jpg',
    tag: 'IMPORTANT NOTICE',
    heading: 'Blocto Wallet is being discontinued',
    body: 'Blocto has discontinued their online wallet service on 20 November 2025 at 2:00 PM AEDT. This is followed by a 7-day maintenance period after which, users must download the Blocto Wallet App and convert to Non-Custodial Mode to access their assets.'
  },
  {
    image: '/assets/Image/blocto-popup.jpg',
    tag: 'IMPORTANT NOTICE',
    heading: 'Your assets are safe',
    isExternalLink: true,
    body: (
      <div>
        After the maintenance period ends (28 Nov 2025 2pm AEDT), please
        download the Blocto Wallet App and convert to Non-Custodial Mode.
        Afterwards, export the JSON file and import it into Flow wallet to
        continue using AFL Mint.
      </div>
    )
  }
]

export const bloctoFeatureModalLink =
  'https://wallet.flow.com/post/migrating-from-blocto-to-flow-wallet'

export const bloctoControlButtonTexts: IControlButtonTexts = {
  prev: 'Back',
  next: 'Next',
  end: 'Show me How'
}
